import React from 'react';
import { twMerge } from 'tailwind-merge';

import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    children: string;
    /**
     * Keeps the space that a list's scrollbar takes, so that the message is
     * centred on the rows it shows in place of.
     */
    reserveScrollbarGutter?: boolean;
}

const NoMatchOnSearch = ({
    children,
    reserveScrollbarGutter = false,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div
            className={twMerge(
                'flex h-full w-full flex-col items-center justify-center leading-8',
                reserveScrollbarGutter && 'scrollbar scrollbar-gutter-stable',
            )}
        >
            <div className="text-gray-900">
                {i18next.t('General.Search.Empty.Title')}
            </div>
            <div className="text-gray-600">{children}</div>
        </div>
    );
};

export default NoMatchOnSearch;
